import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid2';
import Chip from '@mui/material/Chip';
import { Translate, openFile, byteSize, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './place-category.reducer';

const FieldLabel = ({ children }: { children: React.ReactNode }) => (
  <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
    {children}
  </Typography>
);

const FieldValue = ({ children, sx }: { children: React.ReactNode; sx?: object }) => (
  <Typography variant="body1" sx={{ mb: 2, ...sx }}>
    {children || '-'}
  </Typography>
);

const BooleanDisplay = ({ value }: { value?: boolean }) =>
  value ? (
    <Chip icon={<FontAwesomeIcon icon="check" />} label="Yes" color="success" size="small" />
  ) : (
    <Chip icon={<FontAwesomeIcon icon="times" />} label="No" color="error" size="small" />
  );

export const PlaceCategoryDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const placeCategoryEntity = useAppSelector(state => state.placeCategory.entity);
  return (
    <Box sx={{ maxWidth: 1200, mx: 'auto', mt: 4, p: 2 }}>
      <Box sx={{ mb: 4, display: 'flex', alignItems: 'center', gap: 2 }}>
        <h2 data-cy="placeCategoryDetailsHeading">
          <Translate contentKey="jhipsterSampleApplicationApp.placeCategory.detail.title">PlaceCategory</Translate>
        </h2>
        {placeCategoryEntity.id && (
          <Box sx={{ bgcolor: 'primary.light', color: 'primary.contrastText', px: 2, py: 0.5, borderRadius: 1, fontWeight: 'bold' }}>
            ID: {placeCategoryEntity.id}
          </Box>
        )}
      </Box>

      <Grid container spacing={3}>
        <Grid size={{ xs: 12, md: 6 }}>
          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.placeCategory.code" />
          </FieldLabel>
          <FieldValue>{placeCategoryEntity.code}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.placeCategory.enabled" />
          </FieldLabel>
          <BooleanDisplay value={placeCategoryEntity.enabled} />

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.placeCategory.icon" />
          </FieldLabel>
          <FieldValue>{placeCategoryEntity.icon}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.placeCategory.createdDate" />
          </FieldLabel>
          <FieldValue>
            {placeCategoryEntity.createdDate ? (
              <TextFormat value={placeCategoryEntity.createdDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.placeCategory.defaultImage" />
          </FieldLabel>
          <FieldValue>{placeCategoryEntity.defaultImage}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.placeCategory.defaultImageData" />
          </FieldLabel>
          {placeCategoryEntity.defaultImageData ? (
            <Box sx={{ mb: 2 }}>
              {placeCategoryEntity.defaultImageDataContentType ? (
                <a onClick={openFile(placeCategoryEntity.defaultImageDataContentType, placeCategoryEntity.defaultImageData)}>
                  <img
                    src={`data:${placeCategoryEntity.defaultImageDataContentType};base64,${placeCategoryEntity.defaultImageData}`}
                    style={{ maxHeight: '30px' }}
                  />
                </a>
              ) : null}
              <Typography variant="body2" color="text.secondary">
                {placeCategoryEntity.defaultImageDataContentType}, {byteSize(placeCategoryEntity.defaultImageData)}
              </Typography>
            </Box>
          ) : (
            <FieldValue>No image</FieldValue>
          )}
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.placeCategory.createdBy" />
          </FieldLabel>
          <FieldValue>{placeCategoryEntity.createdBy ? placeCategoryEntity.createdBy.login : ''}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.placeCategory.place" />
          </FieldLabel>
          <FieldValue>
            {placeCategoryEntity.places
              ? placeCategoryEntity.places.map((val, i) => (
                  <span key={val.id}>
                    <a>{val.code}</a>
                    {placeCategoryEntity.places && i === placeCategoryEntity.places.length - 1 ? '' : ', '}
                  </span>
                ))
              : null}
          </FieldValue>
        </Grid>

        <Grid size={12}>
          <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
            <Button
              component={Link}
              to="/place-category"
              replace
              color="info"
              variant="outlined"
              startIcon={<FontAwesomeIcon icon="arrow-left" />}
            >
              <Translate contentKey="entity.action.back">Back</Translate>
            </Button>
            <Button
              component={Link}
              to={`/place-category/${placeCategoryEntity.id}/edit`}
              replace
              color="primary"
              variant="contained"
              startIcon={<FontAwesomeIcon icon="pencil-alt" />}
            >
              <Translate contentKey="entity.action.edit">Edit</Translate>
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PlaceCategoryDetail;
